<div class="card-header trial-card-header collapsed" (click)="toggleClinicalTrialsExpander($event)">
  <div class="row">
    <div class="col-7">
      {{ clinicalTrialSubject.researchStudyDisplay.researchStudy.title }}
    </div>
    <div class="col-2">
      {{ therapeuticAreasString | titlecase }}
    </div>
    <div class="col-2">
      {{ clinicalTrialSubject.researchStudyDisplay.phase }}
    </div>
    <div class="col-1 text-right">
      <i aria-hidden="true"></i>
    </div>
  </div>
</div>
<div [attr.id]="'collapse-' + index" class="collapse">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col">
        <lib-trial-details [selectedResearchStudy]="clinicalTrialSubject.researchStudyDisplay"></lib-trial-details>
      </div>
    </div>
    <div class="row">
      <div *ngIf="researchSubjectForm" class="col text-right">
        <strong><span class="text-blue">{{ qualityScore?.numerator?.value }}</span> of {{ qualityScore?.denominator?.value }} Criteria Met</strong>
        <span class="badge rounded-pill selected ml-2">{{ unansweredRequiredCriteria }} Unanswered</span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <app-criteria *ngIf="criteriaForm" [group]="clinicalTrialSubject.researchStudyDisplay.group" [questionnaireResponse]="clinicalTrialSubject.questionnaireResponse" [qualityScoreForm]="qualityScoreForm" [index]="index"></app-criteria>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col my-3">
        <button class="btn btn--blue" type="button" (click)="save()" [disabled]="researchSubjectForm?.pristine">Save</button>
        <a class="btn btn-link" type="button">Cancel</a>
      </div>
    </div>
  </div>
</div>